<template>
  <div class="landing">

    <div class="landing__body">
      <img
        :src="'/images/drawings/GHS-illustrations-DOCUTHEQUE-V3.png'"
        class="landing__body__image"
      >

      <ui-wad class="font-weight-light font-family-heading-jumbo-light color-primary font-size-160 text-align-center line-height-1.3 mb-3">
        Quel plaisir de vous trouver ici !<br>
        Mais ce compte ne dispose d'aucun accès
      </ui-wad>

      <layout-cta-super
        component="ui-button"
        :variant="UI.VARIANT.PRIMARY"
        @click="logout"
      >
        Je me déconnecte
      </layout-cta-super>

      <ui-link
        underline="hover"
        class="d-inline-block mt-3 font-size-90 color-secondary font-family-heading"
        :route="`/account/dispatch?url=https://docutheque.ghs.fr`"
      >
        J'accède à la docuthèque
      </ui-link>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.landing
  @extend %fit-waterline

  background: linear-gradient(to left, $background-tertiary 20%, $background-secondary)

  display: flex
  justify-content: center
  padding-top: 5vh

  &__body
    width: map-get($breakpoints, 'tablet')
    display: flex
    flex-direction: column
    align-items: center

    &__image
      animation: pulse-light 1s ease-in-out alternate-reverse
      animation-iteration-count: infinite

</style>

<script lang="ts">
import { head, Maybe, pipe_, toString, values } from '~/utils/lib/core/prelude'
import { EVENTS as ACCOUNT_EVENTS, observer as accountObserver } from '~/utils/infra/account/types'
import Console from '~/utils/lib/core/console'
import { useLinkHandler } from '~/composables/core/link-handler'
import { useStore_account_authentication } from '~/stores/account/authentication'
import { useToastBuilder } from '~/composables/layout/toast'
import { useStore_client_access, type Structure } from '~/stores/client/access'
import { resetNavigationStorage, storeNavigationStructure } from '~/stores/layout/navigation'
import { routeForUser } from '~/utils/lib/layout/redirection'


const console = new Console('component:user-nil-access')

export default defineNuxtComponent({
  setup() {
    definePageMeta({
      layout: 'blank',
      middleware: [
        'session-control-gate',
        /**
         * @desc Automatic redirection if has some access (by choosing the
         *       first found data)
         */
        async function() {
          const store_client_access = useStore_client_access()
          const mStructure = pipe_(
            values(store_client_access.data),
            head,
            Maybe.toMaybe<Structure>
          )

          if (Maybe.isNothing(mStructure))
            return

          console.log(
            `catched a user with access data, will be redirected`
          )

          const structure = Maybe.fromJust(mStructure)

          resetNavigationStorage()
          storeNavigationStructure(structure.id)

          const redirectionRoute = await routeForUser()

          return navigateTo({ path: redirectionRoute })
        }
      ]
    })
    useHead({
      title: 'Reposez-vous sur GHS',
    })

    const ToastBuilder = useToastBuilder()

    const store_authentication = useStore_account_authentication()

    return {
      ...useLinkHandler(),
      ToastBuilder,
      store_authentication,
    }
  },
  methods: {
    logout() {
      return this.store_authentication.logout()
        .then(() => accountObserver.emit(ACCOUNT_EVENTS.ON_SIGNOUT))
        .catch(err => {
          console.warn(err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Déconnexion`)
            .show()
        })
    }
  },
})
</script>
